import { useCallback, useMemo } from 'react';
import { useSkillCommand } from '../inputBoxHooks';

export const useResetCompareSkills = () => {
  const { isCompareModeSkills, activeSkillCommand, toggleActiveSkillCommand } =
    useSkillCommand();

  const onResetCompareSkills = useCallback(() => {
    if (isCompareModeSkills) {
      return;
    }

    if (activeSkillCommand) {
      toggleActiveSkillCommand(null);
    }
  }, [activeSkillCommand, isCompareModeSkills, toggleActiveSkillCommand]);

  return useMemo(() => ({ onResetCompareSkills }), [onResetCompareSkills]);
};
